import {Application, Graphics} from "pixi.js";

export default class FlappyBirdGame {
    constructor(container) {
        this.container = container;
        this.app = null;
        this.bird = null;
        this.obstacle = null;
        this.velocityX = 0;
        this.velocityY = 0;
        this.gravity = 0.6;
        this.jumpStrength = 9;
        this.drag = 0.98;
        this.radius = 12;
    }

    async init() {
        this.app = new Application();
        await this.app.init({
            width: 900,
            height: 600,
            background: "#87CEEB",
            antialias: true
        });

        this.container.appendChild(this.app.canvas);
        this.setupObjects();
        this.setupInput();
        this.setupLoop();
    }

    setupObjects() {
        this.bird = new Graphics();
        this.bird.circle(0, 0, this.radius);
        this.bird.fill(0xffff00);
        this.bird.x = 100;
        this.bird.y = 300;

        this.obstacle = new Graphics();
        this.obstacle.circle(0, 0, this.radius);
        this.obstacle.fill("red");
        this.obstacle.x = this.app.renderer.width / 2;
        this.obstacle.y = this.app.renderer.height - this.radius;

        this.app.stage.addChild(this.bird);
        this.app.stage.addChild(this.obstacle);
    }

    setupInput() {
        window.addEventListener("keydown", (e) => {
            if (e.code === "ArrowUp") this.velocityY = -this.jumpStrength;
            if (e.code === "ArrowRight") this.velocityX = this.jumpStrength;
            if (e.code === "ArrowLeft") this.velocityX = -this.jumpStrength;
        });
        this.app.canvas.addEventListener("pointerdown", () => {
            this.velocityY = -this.jumpStrength;
        });
    }

    setupLoop() {
        this.app.ticker.maxFPS = 60;
        this.app.ticker.add(() => {
            this.collisionCheck();

            this.velocityY += this.gravity;
            if (this.velocityY > 10) this.velocityY = 10;
            this.bird.y += this.velocityY;

            this.velocityX *= this.drag;
            this.bird.x += this.velocityX;

            const w = this.app.renderer.width;
            const h = this.app.renderer.height;

            if (this.bird.x > w - this.radius) {
                this.bird.x = w - this.radius;
                this.velocityX *= -0.9;
            }

            if (this.bird.x < this.radius) {
                this.bird.x = this.radius;
                this.velocityX *= -0.9;
            }

            if (this.bird.y > h - this.radius) {
                this.bird.y = h - this.radius;
                this.velocityY = this.velocityY > 2 ? -this.velocityY * 0.9 : 0;
            }

            if (this.bird.y < this.radius) {
                this.bird.y = this.radius;
                this.velocityY = 0;
            }
        });
    }

    collisionCheck() {
        const distance = (obj1, obj2) =>
            Math.hypot(obj2.x - obj1.x, obj2.y - obj1.y);

        if (!this.bird || !this.obstacle) return;

        const birdObstacleDistance = distance(this.bird, this.obstacle)

        if (birdObstacleDistance < 2 * this.radius) {
            console.log("Collision detected!");
            this.app.stage.removeChild(this.obstacle);
            this.obstacle.destroy();
            this.obstacle = null;
        }
    }
}
